import React, { useState } from "react";
import { Copy, Check, Volume2, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";

export function TranslationCard({ record }) {
  const { t } = useI18n();
  const [copied, setCopied] = useState(false);
  const [playing, setPlaying] = useState(false);

  const copy = (text) => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  const playTts = async () => {
    setPlaying(true);
    try {
      const { data } = await api.post("/tts", { text: record.translation, lang: record.target_lang });
      const audio = new Audio(`data:audio/mp3;base64,${data.audio_base64}`);
      audio.onended = () => setPlaying(false);
      await audio.play();
    } catch {
      setPlaying(false);
    }
  };

  const transDir = record.target_lang === "ar" ? "rtl" : "ltr";
  const origDir = record.detected_language === "ar" ? "rtl" : "ltr";

  return (
    <div className="animate-pop space-y-2" data-testid="translation-card">
      {/* Original bubble */}
      <div className="flex justify-start">
        <div dir={origDir} className="max-w-[82%] rounded-2xl rounded-ss-sm bg-white border border-border p-3 shadow-sm">
          <div className="text-[11px] uppercase tracking-wider text-muted-foreground mb-1">
            {t("original")} · {record.detected_language === "ar" ? "AR" : "EN"}
            {record.kind === "voice" && " · 🎙"}
          </div>
          <p className="text-[15px] leading-relaxed text-foreground">{record.source_text}</p>
        </div>
      </div>

      {/* Translation bubble */}
      <div className="flex justify-end">
        <div dir={transDir} className="max-w-[82%] rounded-2xl rounded-ee-sm bg-accent text-white p-3 shadow-sm">
          <div className="text-[11px] uppercase tracking-wider text-white/80 mb-1 flex items-center gap-2">
            {t("translation")} · {record.target_lang === "ar" ? "AR" : "EN"}
          </div>
          <p className="text-[15px] leading-relaxed">{record.translation}</p>
          <div className="flex items-center gap-3 mt-2 pt-2 border-t border-white/20">
            <button onClick={() => copy(record.translation)} className="flex items-center gap-1 text-xs text-white/90 hover:text-white" data-testid="copy-translation">
              {copied ? <Check size={13} /> : <Copy size={13} />} {copied ? t("copied") : t("copy")}
            </button>
            <button onClick={playTts} disabled={playing} className="flex items-center gap-1 text-xs text-white/90 hover:text-white" data-testid="play-translation">
              {playing ? <Loader2 size={13} className="animate-spin" /> : <Volume2 size={13} />} {t("listenTranslation")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
